// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"XxxSearchBox_searchBox__3MpVo"};